import React from 'react';

import Category from '@schools/app/pages/category/category';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {}

const CategoryPreview: React.FC<Props> = (props) => {
  return (
    <>
      <div className="u-padding-A-xs" style={{ backgroundColor: colors.purpleLight, color: colors.purple }}>
        <div className="container align-items-center d-flex" style={{ gap: 20 }}>
          <div>
            <strong>Preview Mode</strong>
          </div>
        </div>
      </div>

      <Category preview />
    </>
  )
};

export default CategoryPreview;
